import qs from 'qs';

// Imports => Constants
import { ENDPOINTS } from '@constants';

// Imports => Utilities
import { AcIsSet } from '@utils';

export class OrdersAPI {
	constructor(Instance) {
		this.Client = Instance.Client;
		this.DownloadClient = Instance.DownloadClient;
		this.Store = Instance.Store;
	}

	get = () => {
		return this.Client.get(ENDPOINTS(this.Store.auth.current_role).ORDERS.ALL).then(
			response => response.data
		);
	};

	get_paginated = (_page, _sort, _filters) => {
		let params = {
			paginated: true,
			page: _page,
			sort: _sort,
		};

		if (_filters && Object.keys(_filters)) {
			params.filter = {};
			Object.keys(_filters)
				.filter(key => AcIsSet(_filters[key]))
				.forEach(key => {
					params.filter[key] = _filters[key];
				});
		}

		return this.Client.get(ENDPOINTS(this.Store.auth.current_role).ORDERS.ALL, {
			params,
		}).then(response => response.data);
	};

	get_by_id = _order_id => {
		return this.Client.get(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.GET_BY_ID(_order_id)
		).then(response => response.data);
	};

	create = () => {
		return this.Client.post(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.CREATE
		).then(response => response.data);
	};

	store = (_slot_id, _data) => {
		return this.Client.post(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.STORE(_slot_id),
			_data
		).then(response => response.data);
	};

	download = _order_id => {
		return this.DownloadClient.get(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.DOWNLOAD(_order_id)
		).then(response => response);
	};

	download_specification = (_order_id, _spec_id) => {
		return this.DownloadClient.get(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.DOWNLOAD_SPECIFICATION(
				_order_id,
				_spec_id
			)
		).then(response => response);
	};

	delete = _id => {
		return this.Client.delete(
			ENDPOINTS(this.Store.auth.current_role).ORDERS.DELETE(_id)
		).then(response => response.data);
	};
}

export default OrdersAPI;
